export default __webpack_public_path__ + "static/ir-c14862b9a48216f75d152bb010cebd45.svg";